import React, {useState} from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FileMetaDataTabUserLabels.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import EventEmitter from 'events';
import {FileMetaDataDialog_changeUserLabels} from '../../../init/events';
import {LabelPicker} from '../../LabelPicker/LabelPicker';
import {LabelDTO} from '../../../models/dto/LabelDTO';

export interface FileMetaDataTabUserLabelsProps {
    readonly dataSource: LabelDTO[];
    readonly userLabels?: string[];
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FileMetaDataTabUserLabels
 * @description
 * The dialog to add the metadata of a newly created file or edited file - Metadata Tabs
 */
export const FileMetaDataTabUserLabels: React.VFC<FileMetaDataTabUserLabelsProps> = (props) => {
    const [userLabelsInput, setUserLabelsInput] = useState<string[]>(props.userLabels ?? []);

    const handleChangeUserLabel = (userLabels: string[]) => {
        setUserLabelsInput(userLabels);
        props.eventEmitter.emit(FileMetaDataDialog_changeUserLabels, userLabels);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            <Accordion accordionHeadline={t('UPLOAD_FILE_META_DATA_DIALOG_ACCORDION_LABEL')}
                       startOpen>
                <LabelPicker dataSource={props.dataSource}
                             userLabels={userLabelsInput}
                             onChange={handleChangeUserLabel}/>
            </Accordion>
        </ContentWrapper>
    );
}